/**
 * VERON · Öko-Nudge Loader
 * ------------------------
 * Der Öko-Hinweis (snippets/veron-eco-nudge.liquid) wird serverseitig in den
 * Warenkorb und den Mini-Cart-Drawer gerendert. Der Drawer re-rendert bei jeder
 * Warenkorb-Änderung (Section-Rendering-API), wobei injizierte <script>-Tags
 * NICHT erneut ausgeführt werden. Dieses winzige Skript sorgt dafür, dass der
 * Größen-Finder in jedem frisch gerenderten Nudge initialisiert wird — und lädt
 * das Finder-Bundle ausschließlich dann, wenn tatsächlich ein Nudge sichtbar ist.
 */
(function () {
  'use strict';
  var loading = false;
  var attempts = 0;
  var FAILED = false;

  function bundleSrc() {
    var s = document.querySelector('script[src*="veron-size-advisor.js"]');
    return s ? s.src : null;
  }

  function ready() {
    return window.VeronSizeAdvisor && typeof window.VeronSizeAdvisor.init === 'function';
  }

  function ensure(cb) {
    if (ready()) return cb();
    if (FAILED) return; // nach wiederholtem Ladefehler nicht endlos neu anhängen
    var src = bundleSrc();
    if (!src) return; // Bundle-Referenz (aus dem Snippet) noch nicht im DOM
    if (loading) {
      document.addEventListener('veron:sa-ready', cb, { once: true });
      return;
    }
    loading = true;
    attempts += 1;
    var sc = document.createElement('script');
    sc.src = src;
    sc.defer = true;
    sc.addEventListener('load', function () {
      loading = false;
      document.dispatchEvent(new Event('veron:sa-ready'));
      cb();
    });
    sc.addEventListener('error', function () {
      loading = false;
      sc.remove(); // toten Knoten entfernen
      if (attempts >= 2) FAILED = true; // max. 2 Versuche, dann aufgeben
    });
    document.head.appendChild(sc);
  }

  function initNudges() {
    var hosts = document.querySelectorAll('.veron-eco [data-size-advisor]');
    if (!hosts.length) return;
    var needsInit = false;
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].querySelector('.vsf-trigger')) {
        // Nach Drawer-Morph wird der Host wiederverwendet, aber autoInit guardet
        // auf das JS-Flag host._vsaDone → zurücksetzen, damit neu initialisiert wird.
        hosts[i]._vsaDone = false;
        needsInit = true;
      }
    }
    if (!needsInit) return;
    ensure(function () { if (ready()) window.VeronSizeAdvisor.init(); });
  }

  var raf = 0;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { raf = 0; initNudges(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  // Horizon feuert bei Cart-Änderungen diverse Events — wir hören breit und
  // haben zusätzlich einen (rAF-gedrosselten) MutationObserver als Fallback.
  ['cart:refresh', 'cart:updated', 'cart:change', 'CartUpdateEvent', 'cart-drawer:open'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true });
  }
})();
